import { QrCode } from 'lucide-react'
import { QRCodeSVG } from 'qrcode.react'
import { useState } from 'react'
import * as m from '~/paraglide/messages'
import { formatEurosShort, PREVIEW_QR_PAYLOAD, type TicketFaceData } from './ticket-face'

export function TicketPreview({ ticket }: { ticket: TicketFaceData }) {
  const [flipped, setFlipped] = useState(false)
  const door = ticket.doorPriceCents ? formatEurosShort(ticket.doorPriceCents) : null
  const place = [ticket.venue, ticket.dateLabel].filter(Boolean).join(' · ')

  return (
    <div className="pulsify-ticket w-full max-w-md" data-flipped={flipped}>
      <div className="pulsify-ticket-card">
        <div
          className="pulsify-ticket-side pulsify-ticket-front"
          data-cover={ticket.coverUrl !== null}
          inert={flipped}
        >
          {ticket.coverUrl ? (
            <>
              <img className="pulsify-ticket-cover" src={ticket.coverUrl} alt="" loading="lazy" />
              <span className="pulsify-ticket-veil" />
            </>
          ) : null}
          <span className="pulsify-ticket-light" />
          <span className="pulsify-ticket-grain" />
          <div className="pulsify-ticket-main">
            <div className="pulsify-ticket-small">
              <p className="pulsify-ticket-line">{ticket.eventTitle}</p>
              <p className="pulsify-ticket-line">{ticket.typeName}</p>
            </div>
            <p className="pulsify-ticket-name">{ticket.holderName}</p>
            <div className="pulsify-ticket-bottom pulsify-ticket-small">
              <p className="pulsify-ticket-line">{place}</p>
              {door ? (
                <span className="pulsify-ticket-chip">
                  {m.ticketPreviewDoorChip({ amount: door })}
                </span>
              ) : null}
            </div>
          </div>
          <span className="pulsify-ticket-perforation" />
          <button
            type="button"
            className="pulsify-ticket-stub"
            aria-label={m.ticketPreviewShowQr()}
            onClick={() => setFlipped(true)}
          >
            <span aria-hidden className="pulsify-ticket-day">
              {ticket.day}
            </span>
            <span className="pulsify-ticket-vertical pulsify-ticket-admit">
              {m.ticketPreviewAdmit()}
            </span>
            <span className="pulsify-ticket-round">
              <QrCode aria-hidden className="size-5" />
            </span>
          </button>
        </div>

        <div className="pulsify-ticket-side pulsify-ticket-back" inert={!flipped}>
          <div className="pulsify-ticket-main">
            <div className="pulsify-ticket-qr">
              <QRCodeSVG
                value={PREVIEW_QR_PAYLOAD}
                marginSize={0}
                fgColor="currentColor"
                bgColor="transparent"
              />
            </div>
            <div className="pulsify-ticket-back-lines">
              <p className="pulsify-ticket-line">{ticket.typeName}</p>
              {door ? <p>{m.ticketPreviewDoorPay({ amount: door })}</p> : null}
              {ticket.isStudent ? <p>{m.ticketPreviewStudentHint()}</p> : null}
            </div>
          </div>
          <span className="pulsify-ticket-perforation" />
          <button
            type="button"
            className="pulsify-ticket-stub"
            aria-label={m.ticketPreviewBack()}
            onClick={() => setFlipped(false)}
          >
            <span className="pulsify-ticket-vertical pulsify-ticket-reference">
              {ticket.reference}
            </span>
            <span className="pulsify-ticket-pill">{m.ticketPreviewBack()}</span>
          </button>
        </div>
      </div>
    </div>
  )
}
